/* assets/min-order.js
   Disables every checkout button/link while the cart subtotal is below the minimum
   and shows "Add $X more" under it. Works on cart page and cart drawer. */
(function () {
  if (window.__minOrderInit) return;
  window.__minOrderInit = true;

  const MIN = Math.round((window.MIN_ORDER || 24) * 100); // cents
  const nativeFetch = window.fetch.bind(window);

  // Add/adjust selectors if your theme's checkout button uses something else
  const SEL = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]',
    '[data-cart-checkout]',
    '.cart__checkout-button',
  ].join(',');

  let short = 0;

  const money = (cents) =>
    new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    }).format(cents / 100);

  function apply() {
    const block = short > 0;
    document.querySelectorAll(SEL).forEach((el) => {
      if ('disabled' in el) el.disabled = block;
      el.setAttribute('aria-disabled', block ? 'true' : 'false');
      el.style.opacity = block ? '.45' : '';
      el.style.pointerEvents = block ? 'none' : '';

      let note = el.parentElement && el.parentElement.querySelector(':scope > .min-order-notice');
      if (block) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'min-order-notice';
          note.setAttribute('role', 'alert');
          note.style.cssText = 'margin:8px 0 0;font-size:13px;text-align:center;';
          el.insertAdjacentElement('afterend', note);
        }
        note.textContent = 'Minimum order is ' + money(MIN) + '. Add ' + money(short) + ' more to checkout.';
      } else if (note) {
        note.remove();
      }
    });
  }

  async function refresh() {
    try {
      const cart = await (await nativeFetch('/cart.js')).json();
      // items_subtotal_price excludes $0 free samples automatically
      short = cart.item_count > 0 ? Math.max(0, MIN - cart.items_subtotal_price) : 0;
      apply();
    } catch (e) {}
  }

  // Safety net: stop any click / submit that would go to checkout
  document.addEventListener(
    'click',
    (e) => {
      if (short > 0 && e.target.closest && e.target.closest(SEL)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );
  document.addEventListener(
    'submit',
    (e) => {
      if (short > 0 && e.submitter && e.submitter.name === 'checkout') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // Re-check after any cart change
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : input && input.url;
    const p = nativeFetch.apply(this, arguments);
    if (url && /\/cart\/(add|change|update|clear)/.test(url)) p.then(() => setTimeout(refresh, 500));
    return p;
  };

  // Cart drawer / page re-renders
  let t;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(apply, 150);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('free-sample:updated', refresh);
  window.addEventListener('load', refresh);
  refresh();
})();
